/** 构建时由 webpack DefinePlugin 注入 process.env.BRAND（eweadn | exx | …） */
const DEFAULT_BRAND_ID = "eweadn";

/** 当前运行/打包品牌 id（小写，与 brand-config/brands/{id} 一致） */
export function getActiveBrandId(): string {
  // 须直接写 process.env.BRAND，供 DefinePlugin 编译期内联；浏览器无 Node process 对象
  const raw = process.env.BRAND;
  if (typeof raw === "string" && raw.trim()) {
    return raw.trim().toLowerCase();
  }
  return DEFAULT_BRAND_ID;
}

export function normalizeDeviceBrand(brand: unknown): string | undefined {
  if (typeof brand !== "string") return undefined;
  const trimmed = brand.trim();
  return trimmed ? trimmed.toLowerCase() : undefined;
}

/**
 * 设备是否属于当前品牌：
 * - 配置行带 brand：须与 getActiveBrandId() 一致（大小写不敏感）
 * - 未带 brand：仅默认品牌 eweadn 可见（前行者全量型号）
 */
export function deviceMatchesActiveBrand(
  device: { brand?: unknown },
  activeBrandId: string = getActiveBrandId()
): boolean {
  const active = activeBrandId.trim().toLowerCase();
  const deviceBrand = normalizeDeviceBrand(device.brand);
  if (!deviceBrand) {
    return active === DEFAULT_BRAND_ID;
  }
  return deviceBrand === active;
}

export function filterDevicesByActiveBrand<T extends { brand?: unknown }>(
  devices: T[],
  activeBrandId: string = getActiveBrandId()
): T[] {
  return devices.filter((d) => deviceMatchesActiveBrand(d, activeBrandId));
}

export function filterSupportedDevicesMapByBrand<T extends { brand?: unknown }>(
  data: { keyboard: T[]; mouse: T[]; earphone?: T[] },
  activeBrandId?: string
): {
  keyboard: T[];
  mouse: T[];
  earphone: T[];
} {
  const brandId = activeBrandId ?? getActiveBrandId();
  return {
    keyboard: filterDevicesByActiveBrand(data.keyboard, brandId),
    mouse: filterDevicesByActiveBrand(data.mouse, brandId),
    earphone: filterDevicesByActiveBrand(data.earphone ?? [], brandId),
  };
}
